import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';

// Instantiate a single QueryClient for the lifetime of the app.  See
// https://tanstack.com/query/latest/docs/framework/react/reference/QueryClient
const queryClient = new QueryClient();

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// Pages written by the static generator (scripts/seo) already contain the
// rendered markup, so React attaches to it instead of re-rendering.
if (container.dataset.prerendered === 'true') {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
